import { getCurrentStep } from './getCurrentStep';

export const generateFallbackStep = (flowConfig, props) => {
  // flowConfig.fallbackConfig.stepNotFoundPath can be a string that targets a reducer,
  // so we check for that first, otherwise we just return the string
  // which should be a URL path
  const fallbackPath = props[flowConfig.stepNotFoundPath] || flowConfig.stepNotFoundPath;
  let fallbackStep = getCurrentStep(flowConfig, props, {
    pathOverride: fallbackPath,
  });

  // if the config has a fallback path, we dont want to return the first step, but rather
  // redirect to a different URL, so the currentStepAccordingToPath will be NULL
  if (!fallbackStep) {
    fallbackStep = {
      id: `path-from-fallback/${fallbackPath}`,
      path: fallbackPath,
      prerequisite: true,
    };
  }
  fallbackStep.isFallback = true;
  return fallbackStep;
};
